export const RESULT_CHECK_HEALTHTOOLS = 'result_check_healthtools';